import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6af6f695")

_pushScopeId("data-v-6af6f695")
const _hoisted_1 = {
  class: "Ecard",
  id: "trendChart"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("提交")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode(_component_el_form, {
                  model: _ctx.form,
                  "label-width": "120px"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, { label: "playerid_src" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.form.playerid_src,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.playerid_src = $event)),
                          style: {"width":"100px"},
                          size: "small"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "playerid_dst" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.form.playerid_dst,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.playerid_dst = $event)),
                          size: "small",
                          style: {"width":"100px","margin-bottom":"5px"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, null, {
                      default: _withId(() => [
                        _createVNode(_component_el_button, {
                          size: "small",
                          style: {"padding":"0 20px"},
                          type: "primary",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.subBtn(_ctx.form.playerid_src, _ctx.form.playerid_dst)))
                        }, {
                          default: _withId(() => [
                            _hoisted_2
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})